import { t } from "i18next";

import { MaintenanceStrategyTriggerType } from "@/api/resources/maintenanceStrategyTriggers/types";
import i18n from "@/providers/i18n";
import { TriggerMetricType, type MaintenanceStrategyInterval, type MaintenanceStrategyTrigger } from "@/supabase.types";
import { getDateDurationMsHumanized } from "@/utils/dates";

export const getMaintenanceStrategyTriggerType = ({
  interval,
  trigger,
}: {
  interval?: MaintenanceStrategyInterval | null;
  trigger?: MaintenanceStrategyTrigger | null;
}) => {
  if (!trigger?.window_size && !interval) return MaintenanceStrategyTriggerType.Usage;
  else if (trigger?.window_size) return MaintenanceStrategyTriggerType.Anomaly;
  else if (interval && !trigger) return MaintenanceStrategyTriggerType.Schedule;
  return undefined;
};

export function readableMaintenanceStrategyTrigger(
  trigger: Pick<MaintenanceStrategyTrigger, "metric" | "window_size" | "threshold">,
) {
  let metricStr = "";
  if (trigger.metric === TriggerMetricType.N_ERRORS) metricStr = t("errors");
  else metricStr = t("missions");

  if (!trigger.window_size) {
    return `${i18n.t("every")} ${trigger.threshold} ${metricStr}`;
  }
  const humanizedDuration = getDateDurationMsHumanized(trigger.window_size * 1000);

  return `${trigger.threshold} ${metricStr} ${i18n.t("within")} ${humanizedDuration}`;
}
